export default __webpack_public_path__ + "static/media/DiscoveryChannel.2cd64844.svg";